import React, { useMemo } from "react";
import { Thumbnails } from "./components/Thumbnails";
import { Affix } from "./components/Affix";
import { Header } from "./components/Header";

export const useCarouselComponents = (
  childrensArray: React.ReactNode[],
  handleAffixAction: (action: "next" | "prev") => void,
  updateSlide: (index: number) => void
) => {
  const thumbnails = useMemo(() => {
    return React.Children.map(childrensArray, (child) => {
      if (React.isValidElement(child) && child.type === Thumbnails) {
        return React.cloneElement(child as React.ReactElement, {
          updateSlide,
        });
      }
    });
  }, [childrensArray, updateSlide]);

  const affix = React.Children.map(childrensArray, (child) => {
    if (React.isValidElement(child) && child.type === Affix) {
      return React.cloneElement(child as React.ReactElement, {
        handleAffixAction,
      });
    }
  });

  const header = useMemo(
    () =>
      childrensArray.find(
        (child) => React.isValidElement(child) && child.type === Header
      ),
    [childrensArray]
  );

  return {
    thumbnails,
    affix,
    header,
  };
};
